import React from 'react'
import Icon from '@components/atoms/Icon'
import Image from '@components/atoms/Image'
import { Swiper, SwiperSlide } from '@components/molecules/Slider'
import { CollectionsData } from '@interfaces/collection'

const Carousel: React.FC<CollectionsData> = ({ collections }) => {
  if (!collections || collections.length === 0) {
    console.log('Section data: empty for carousel')
    return null
  }

  return (
    <div className="flex flex-wrap justify-center items-center md:mx-16">
      <Swiper
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={1.6}
        loop={true}
        pagination={{
          el: '.carousel-pagination',
          type: 'bullets',
          clickable: true,
        }}
        navigation={{
          nextEl: '.carousel-button-next',
          prevEl: '.carousel-button-prev',
        }}
        effect={'coverflow'}
        coverflowEffect={{
          rotate: 40,
          stretch: 30,
          depth: 240,
          modifier: 1.5,
          slideShadows: false,
        }}
        breakpoints={{
          768: {
            slidesPerView: 3.1,
            coverflowEffect: {
              rotate: 23,
              stretch: 0,
            },
          },
          1024: {
            slidesPerView: 3.1,
            coverflowEffect: {
              rotate: 26,
              stretch: 1,
            },
          },
          1440: {
            slidesPerView: 3.1,
            coverflowEffect: {
              rotate: 26,
              stretch: 0,
            },
          },
        }}
      >
        {collections.map((collection, index) => (
          <SwiperSlide key={index}>
            <div className="rounded-t-3xl overflow-hidden relative">
              {collection.featured_image ? (
                <>
                  <a href={collection.url}>
                    <Image
                      alt={collection.featured_image.alt}
                      src={collection.featured_image.src}
                      srcWidths={{ sm: 640 }}
                      height={800}
                      width={640}
                      classes="w-full aspect-[480/480] object-cover rounded-3xl"
                    />
                    <Image
                      alt={collection.featured_image.alt}
                      src={collection.featured_image.src}
                      srcWidths={{ sm: 640 }}
                      height={800}
                      width={640}
                      classes="w-full object-cover rounded-b-3xl image-reflection"
                    />
                  </a>
                </>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: collection.placeholder_svg || '',
                  }}
                  className="w-full h-full bg-white"
                />
              )}
              <a
                href={collection.url}
                className="carousel-cta font-appleGaramond bg-white no-underline border rounded-2xl text-black text-[24px] py-5 px-10 absolute bottom-0 left-1/2 lg:text-[32px] transform -translate-x-1/2"
              >
                {collection.title}
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="flex items-center justify-center space-x-4 mt-4" role="group" aria-label="Carousel controls">
        {/* Previous Button */}
        <button
          type="button"
          className="carousel-button-prev flex-shrink-0 flex justify-center items-center cursor-pointer bg-white/50 border-none text-center font-extrabold rounded-full w-11 h-11 p-3.75"
          aria-label="Previous slide"
          tabIndex={0}
        >
          <Icon name="carousel-arrow-left" aria-hidden="true" />
        </button>

        {/* Pagination */}
        <div className="carousel-pagination text-center" role="region" aria-label="Carousel pagination"></div>

        {/* Next Button */}
        <button
          type="button"
          className="carousel-button-next flex-shrink-0 flex justify-center items-center cursor-pointer bg-white/50 border-none text-center font-extrabold rounded-full w-11 h-11 p-3.75"
          aria-label="Next slide"
          tabIndex={0}
        >
          <Icon name="carousel-arrow-right" aria-hidden="true" />
        </button>
      </div>
    </div>
  )
}

export default Carousel
